module.exports = __webpack_public_path__ + "img/absorbente4.d15d7743.jpg";